<template>

  <div ref="screenshotDOM" class="screenshotDOM" :class="{ hidden: screenshotTaken }">
    <p class="fat-text" style="margin-bottom: 2rem">
      {{ $t("stageTwoThree.savings") }}
    </p>
    <p>
      {{
        $t("stageTwoThree.calculateSavings", {
          modules: calculationData.modules,
          power: calculationData.modulePower
        })
      }}
    </p>

    <el-row>
      <el-col :span="24" class="component-container">
        <div class="box-component">
          <el-row>
            <el-col :span="8" class="data-item">
              <span>{{ $t("stageTwoThree.CO2Saved1") }}</span>
              <p>
                <img class="data-icon" src="/src/assets/icons/icon-leaf.svg" />
                {{
                  calculationData.savedCO2
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                }}
                kg/CO<sub>2</sub>
              </p>
              <span>{{ $t("stageTwoThree.CO2Saved2") }}</span>
            </el-col>
            <el-col :span="8" class="data-item">
              <span>{{ $t("stageTwoThree.yearlyProd1") }}</span>
              <p>
                <img
                    class="data-icon"
                    src="/src/assets/icons/icon-e-loading.svg"
                />
                {{
                  Math.round(calculationData.yearlyProd)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                }}
                kWh
              </p>
              <span>{{ $t("stageTwoThree.yearlyProd2") }}</span>
            </el-col>
            <el-col :span="8" class="data-item">
              <span>{{ $t("stageTwoThree.yearlyLessPercentage1") }}</span>
              <p>
                <img class="data-icon" src="/src/assets/icons/icon-money.svg" />
                {{ calculatedPercentageSavings }} %
              </p>
              <span>{{ $t("stageTwoThree.yearlyLessPercentage2") }}</span>
            </el-col>
            <el-col :span="8" class="data-item">
              <span>{{ $t("stageTwoThree.evStats1") }}</span>
              <p>
                <img class="data-icon" src="/src/assets/icons/icon-e-car.svg" />
                {{
                  calculationData.EVDriveLength.toString().replace(
                      /\B(?=(\d{3})+(?!\d))/g,
                      " "
                  )
                }}
                km
              </p>
              <span>{{ $t("stageTwoThree.evStats2") }}</span>
            </el-col>
            <el-col :span="8" class="data-item">
              <span>{{ $t("stageTwoThree.treeStats1") }}</span>
              <p>
                <img class="data-icon" src="/src/assets/icons/icon-tree.svg" />
                {{
                  calculationData.treeBinding
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                }}
                {{ $t("stageTwoThree.treeStats2") }}
              </p>
              <span>{{ $t("stageTwoThree.treeStats3") }}</span>
            </el-col>
            <el-col :span="8" class="data-item">
              <span>{{ $t("stageTwoThree.saunaStats1") }}</span>
              <p>
                <img class="data-icon" src="/src/assets/icons/icon-sauna.svg" />
                {{
                  calculationData.saunasHeated
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                }}
                {{ $t("stageTwoThree.saunaStats2") }}
              </p>
              <span>{{ $t("stageTwoThree.saunaStats3") }}</span>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24" class="component-container">
        <div class="box-component chart-container">
          <p class="fat-text">{{ $t("stageTwoThree.energyByMonth") }}</p>
          <MonthlyChart @animationComplete="takeScreenshot" :calculationData="calculationData" />
        </div>
      </el-col>
    </el-row>

    <p class="fat-text">{{ $t("stageTwoThree.income") }}</p>

    <el-row>
      <el-col :span="24" class="component-container">
        <div class="box-component">
          <el-row>
            <el-col :span="8" class="data-item">
              <span>{{ $t("stageTwoThree.estimatedSurplus") }}</span>
              <p class="data-text">
                <img
                    class="data-icon"
                    src="/src/assets/icons/icon-progress.svg"
                />
                {{ calculationData.surplusEarnings }}
                {{ $t("stageTwoThree.moneyPerWeek") }}
              </p>
            </el-col>
            <el-col :span="8" class="data-item">
              <span>{{ $t("stageTwoThree.estimatedEnergySavings") }}</span>
              <p class="data-text">
                <img class="data-icon" src="/src/assets/icons/icon-money.svg" />
                {{ calculationData.indicativeSavings }}
                {{ $t("stageTwoThree.moneyPerWeek") }}
              </p>
            </el-col>
            <!-- What is this?
          <el-col :span="8" class="data-item">
            <span>{{ $t("stageTwoThree.estimatedYearlyProduction") }}</span>
            <p class="data-text">
              <img class="data-icon" src="/src/assets/icons/icon-co2leaf.svg">
              ??? kg/CO<sub>2</sub></p>
          </el-col>
          <el-col :span="8" class="data-item">
          </el-col>
          -->
          </el-row>
        </div>
      </el-col>
    </el-row>

    <p class="fat-text" v-if="showBudget === 'true'">Kustannusarvio</p>

    <el-row v-if="showBudget === 'true'">
      <el-col :span="24" class="component-container">
        <div class="box-component">

          <el-row>
            <el-col :span="8" class="data-item" style="margin-bottom: 0">
              <span>Hinta</span>
              <p>
                <img class="data-icon" src="/src/assets/icons/icon-money.svg" />
                <span v-if="props.budget[1] === 1">{{ props.calculatedPrice[1]+props.budget[0] }}  €</span><span v-else>-</span>
              </p>
              <span>ALV0%</span>
            </el-col>

            <el-col :span="8" class="data-item" style="margin-bottom: 0">
              <span>€/paneeli</span>
              <p>
                <img class="data-icon" src="/src/assets/icons/icon-money.svg" />
                <span v-if="props.budget[1] === 1">{{ ((props.calculatedPrice[1]+props.budget[0])/props.calculationData.modules).toFixed(0) }} €</span><span v-else>-</span>
              </p>
              <span>ALV0%</span>
            </el-col>

            <el-col :span="8" class="data-item" style="margin-bottom: 0">
              <span>€/kW</span>
              <p>
                <img class="data-icon" src="/src/assets/icons/icon-money.svg" />
                <span v-if="props.budget[1] === 1">{{ (Math.round((props.calculatedPrice[1]+props.budget[0])/props.calculationData.modulePower)/1000).toFixed(2) }} €</span><span v-else>-</span>
              </p>
              <span>ALV0%</span>
            </el-col>

          </el-row>
          <el-row>
            <div style="margin-top: 2rem; font-size: 13px;">
              <p>Laskurin antaman hinnat ovat kaikilta osin alustavia eivät sido osapuolia millään tavalla. Sitovan hintatarjouksen ottamalla yhteyttä Naps-myyntiin</p>
            </div>
          </el-row>
        </div>
      </el-col>
    </el-row>
  </div>

  <p class="fat-text" style="margin-bottom: 2rem">
    {{ $t("stageTwoThree.savings") }}
  </p>
  <p>
    {{
      $t("stageTwoThree.calculateSavings", {
        modules: calculationData.modules,
        power: calculationData.modulePower
      })
    }}
  </p>

  <el-row>
    <el-col :span="24" class="component-container">
      <div class="box-component">
        <el-row>
          <el-col :span="8" class="data-item">
            <span>{{ $t("stageTwoThree.CO2Saved1") }}</span>
            <p>
              <img class="data-icon" src="/src/assets/icons/icon-leaf.svg" />
              {{
                calculationData.savedCO2
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
              }}
              kg/CO<sub>2</sub>
            </p>
            <span>{{ $t("stageTwoThree.CO2Saved2") }}</span>
          </el-col>
          <el-col :span="8" class="data-item">
            <span>{{ $t("stageTwoThree.yearlyProd1") }}</span>
            <p>
              <img
                class="data-icon"
                src="/src/assets/icons/icon-e-loading.svg"
              />
              {{
                Math.round(calculationData.yearlyProd)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
              }}
              kWh
            </p>
            <span>{{ $t("stageTwoThree.yearlyProd2") }}</span>
          </el-col>
          <el-col :span="8" class="data-item">
            <span>{{ $t("stageTwoThree.yearlyLessPercentage1") }}</span>
            <p>
              <img class="data-icon" src="/src/assets/icons/icon-money.svg" />
              {{ calculatedPercentageSavings }} %
            </p>
            <span>{{ $t("stageTwoThree.yearlyLessPercentage2") }}</span>
          </el-col>
          <el-col :span="8" class="data-item">
            <span>{{ $t("stageTwoThree.evStats1") }}</span>
            <p>
              <img class="data-icon" src="/src/assets/icons/icon-e-car.svg" />
              {{
                calculationData.EVDriveLength.toString().replace(
                  /\B(?=(\d{3})+(?!\d))/g,
                  " "
                )
              }}
              km
            </p>
            <span>{{ $t("stageTwoThree.evStats2") }}</span>
          </el-col>
          <el-col :span="8" class="data-item">
            <span>{{ $t("stageTwoThree.treeStats1") }}</span>
            <p>
              <img class="data-icon" src="/src/assets/icons/icon-tree.svg" />
              {{
                calculationData.treeBinding
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
              }}
              {{ $t("stageTwoThree.treeStats2") }}
            </p>
            <span>{{ $t("stageTwoThree.treeStats3") }}</span>
          </el-col>
          <el-col :span="8" class="data-item">
            <span>{{ $t("stageTwoThree.saunaStats1") }}</span>
            <p>
              <img class="data-icon" src="/src/assets/icons/icon-sauna.svg" />
              {{
                calculationData.saunasHeated
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
              }}
              {{ $t("stageTwoThree.saunaStats2") }}
            </p>
            <span>{{ $t("stageTwoThree.saunaStats3") }}</span>
          </el-col>
        </el-row>
      </div>
    </el-col>
  </el-row>

  <el-row>
    <el-col :span="24" class="component-container">
      <div class="box-component chart-container">
        <p class="fat-text">{{ $t("stageTwoThree.energyByMonth") }}</p>
        <MonthlyChart :calculationData="calculationData" />
      </div>
    </el-col>
  </el-row>

  <p class="fat-text">{{ $t("stageTwoThree.income") }}</p>

  <el-row>
    <el-col :span="24" class="component-container">
      <div class="box-component">
        <el-row>
          <el-col :span="8" class="data-item">
            <span>{{ $t("stageTwoThree.estimatedSurplus") }}</span>
            <p class="data-text">
              <img
                  class="data-icon"
                  src="/src/assets/icons/icon-progress.svg"
              />
              {{ calculationData.surplusEarnings }}
              {{ $t("stageTwoThree.moneyPerWeek") }}
            </p>
          </el-col>
          <el-col :span="8" class="data-item">
            <span>{{ $t("stageTwoThree.estimatedEnergySavings") }}</span>
            <p class="data-text">
              <img class="data-icon" src="/src/assets/icons/icon-money.svg" />
              {{ calculationData.indicativeSavings }}
              {{ $t("stageTwoThree.moneyPerWeek") }}
            </p>
          </el-col>
          <!-- What is this?
        <el-col :span="8" class="data-item">
          <span>{{ $t("stageTwoThree.estimatedYearlyProduction") }}</span>
          <p class="data-text">
            <img class="data-icon" src="/src/assets/icons/icon-co2leaf.svg">
            ??? kg/CO<sub>2</sub></p>
        </el-col>
        <el-col :span="8" class="data-item">
        </el-col>
        -->
        </el-row>
      </div>
    </el-col>
  </el-row>

<!--
  <img ref="temp" :src="resultingScreenshot" v-if="resultingScreenshot" />
-->

</template>

<script lang="ts" setup>
import type { CalculationData } from "@/types";
import MonthlyChart from "@/components/charts/MonthlyChart.vue";
import {computed, ref} from "vue";
import domtoimage from 'dom-to-image-more';

const props = defineProps<{
  calculatedPrice: number[];
  calculationData: CalculationData;
  budget: number[];
  showBudget: string | undefined;
}>();

const emit = defineEmits(["emitResultScreenshot"]);

const screenshotDOM = ref(null)
const resultingScreenshot = ref<string>();
const screenshotTaken = ref<boolean>(false);

const calculatedPercentageSavings = computed(() =>
  Math.round(
    (props.calculationData.yearlyProd /
      props.calculationData.currentYearlyConsumption) *
      100
  )
);

function takeScreenshot(){
  if (screenshotTaken.value === false) {
    domtoimage
        .toPng(screenshotDOM.value)
        .then((dataUrl: any) => {
          resultingScreenshot.value = dataUrl;
          screenshotTaken.value = true;
          emitScreenshot();
        }).catch((error: any) => {
      console.error("oops, something went wrong!", error);
      screenshotTaken.value = true;
      emitScreenshot();
    });
  }
}

function emitScreenshot() {
  console.log("Emitting screenshot!")
  emit("emitResultScreenshot", [resultingScreenshot.value, screenshotTaken.value]);
}

</script>
